import { Box, Typography } from "@mui/material";
import { layoutStyles } from "../theme/appTheme";

const MainPage = () => {
    return (
        <Box sx={layoutStyles.mainPanel}>
            <Typography variant="h6" align="center" color="text.secondary">
                Seleccione un item del menú
            </Typography>
        </Box>
    );
};

export default MainPage;
